<template>
    <div>
    </div>
</template>
<script>
import * as NotifyMixin from "./NotifyMixin.vue";
    export default {
        mixins: [NotifyMixin],
        props:["channel"],       
        mounted() {                        
            // console.log("is mobile", this.isMobile());
            if(this.channel && !this.isMobile()){
                this.getMessage(this.channel);
            }
        },   
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/notify/NotifyMessage.vue